import { useGetCompanyName } from '#entities/company';
import { STORE_TYPE_LITE } from '#shared/lib/const';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { checkStoreType, getLocalStoreModerationOverrides } from '#shared/lib/storeInfo';

type CompanyNameModerationParams = {
    moderationErrorOverride?: boolean;
    shouldFetchCompanyName: boolean;
};

const getCompanyNameModerationParams = (isLiteStore: boolean): CompanyNameModerationParams => {
    if (!getSafeUserRequestContext().isInternalYandexUser) {
        return {
            shouldFetchCompanyName: isLiteStore,
        };
    }

    const moderationErrorOverride = getLocalStoreModerationOverrides().hasCompanyNameModerationError;

    return {
        moderationErrorOverride,
        shouldFetchCompanyName: isLiteStore && moderationErrorOverride === undefined,
    };
};

export const useCompanyNameModerationBanner = () => {
    const isLiteStore = checkStoreType([STORE_TYPE_LITE]);
    const { moderationErrorOverride, shouldFetchCompanyName } = getCompanyNameModerationParams(isLiteStore);
    const { data, isFetching } = useGetCompanyName(undefined, { skip: !shouldFetchCompanyName });

    return {
        isOpen: isLiteStore && (moderationErrorOverride ?? data?.status === 'error'),
        isLoading: shouldFetchCompanyName && isFetching && data === undefined,
    };
};
